export default __webpack_public_path__ + "static/media/ekip-etkinlikleri.43cf3010.jpg";